import Axios from "axios";
import store from "../store";
import router from "@/router";

const config = { baseURL: process.env.VUE_APP_URL };
const axiosAPIistance = Axios.create(config);

axiosAPIistance.interceptors.request.use(
  async function (config) {
    try {
      var token = localStorage.getItem("access_Token") || store.state["authPageModule"].access_Token;
      if (token) {
        const refreshToken = localStorage.getItem("refresh_token");
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Re-Authorization"] = `Bearer ${refreshToken}`;
      }
    } catch (error) {}

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosAPIistance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const code = parseInt(error.response && error.response.status);
    const originalRequest = error.config;

    if (code === 401 && !originalRequest._retry) {

      originalRequest._retry = true;
      return axiosAPIistance({
        method: "POST",
        url: "/business/loginRefresh",
      }).then((res) => {
        if (res.status === 200) {
          localStorage.setItem("access_Token", res.data["access_Token"]);
          localStorage.setItem("refresh_token", res.data["refresh_token"]);
        }
        return axiosAPIistance(originalRequest);
      });
    } else if (code === 403) {
      store.commit("snackbarFailed", {
        value: true,
        msg: error.response.data,
      });
      router.push({ path: "/" });
    } else if (code === 400) {
      
    } else if (code === 406) {
      console.log("logout");
    
      localStorage.removeItem("access_Token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
    
      router.push({ path: "/login" });
     
    }else if (code >= 500) {
      store.commit("snackbarFailed", {
        value: true,
        msg: error.response.data.error_message,
      });
    }

    return Promise.reject(error);
  }
);

export default axiosAPIistance;
